import React from 'react';
import { Donor } from '../../models/Donor';
import DonorCard from '../../components/DonorCard';

type Props = {
  donor: Donor;
}

const DonorListItem = ({ donor }: Props) => {
  return (
    <li>
      <DonorCard donor={ donor } />
    </li>
  );
};

export default DonorListItem;
